import { render } from "./FloatingAudioPlayer.vue?vue&type=template&id=830a6a88&scoped=true"
import script from "./FloatingAudioPlayer.vue?vue&type=script&lang=js"
export * from "./FloatingAudioPlayer.vue?vue&type=script&lang=js"

import "./FloatingAudioPlayer.vue?vue&type=style&index=0&id=830a6a88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-830a6a88"]])

export default __exports__